import { useRef, useState } from "react";
import { Camera, User } from "lucide-react";
import { photoUrl, uploadPhoto } from "../lib/photos";
import { toast } from "sonner";

export default function PhotoUpload({ value, token, onUpload, size = 96 }) {
  const inputRef = useRef(null);
  const [busy, setBusy] = useState(false);
  const [preview, setPreview] = useState(null);

  const onPick = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    if (file.size > 5 * 1024 * 1024) {
      toast.error("Image must be under 5MB");
      return;
    }
    setPreview(URL.createObjectURL(file));
    setBusy(true);
    try {
      const path = await uploadPhoto(file, token);
      onUpload(path);
      toast.success("Photo uploaded");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Upload failed");
      setPreview(null);
    } finally {
      setBusy(false);
    }
  };

  const src = preview || photoUrl(value);
  return (
    <div className="flex items-center gap-4">
      <button
        type="button"
        data-testid="photo-upload-btn"
        onClick={() => inputRef.current?.click()}
        className="relative rounded-full overflow-hidden border-2 border-dashed hover:border-solid transition-all"
        style={{ width: size, height: size, borderColor: "var(--secondary)" }}
      >
        {src ? (
          <img src={src} alt="Profile" className="w-full h-full object-cover" />
        ) : (
          <div className="w-full h-full grid place-items-center bg-neutral-100">
            <User className="w-8 h-8 text-neutral-400" />
          </div>
        )}
        <div className="absolute inset-x-0 bottom-0 py-1 text-white text-[10px] font-bold text-center" style={{ background: "rgba(29,46,95,0.7)" }}>
          {busy ? "…" : (
            <span className="inline-flex items-center gap-1"><Camera className="w-3 h-3" /> {src ? "Change" : "Add"}</span>
          )}
        </div>
      </button>
      <input
        ref={inputRef}
        type="file"
        accept="image/jpeg,image/png,image/webp"
        className="hidden"
        onChange={onPick}
      />
      <div className="text-xs text-neutral-500 max-w-[16ch] leading-snug">
        Add a friendly photo — it helps customers trust you.
      </div>
    </div>
  );
}
